export const clamp = (v: number, min: number, max: number) => Math.min(Math.max(v, min), max);

export const limits = (dtype: `s${number}` | `u${number}`) =>
  Math.pow(2, parseInt(dtype.substring(1)) - Number(!dtype.startsWith('u'))) - 1;
